module.exports = __webpack_public_path__ + "img/pro_one_8.49e77a49.jpg";